import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialogViewModel from "./../../factories/bao-dialog";
class ConfigurationItemInstalledSoftwareViewModel extends GenericListSearchTab {
    public Bao: any;
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() { return "Software"; }
    CustomFilter() {
        return null;
    }
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Bao = Bao;
        this.SaveAllowed = parent.SaveAllowed;
    }
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default ConfigurationItemInstalledSoftwareViewModel;